import type { Rule } from 'antd/lib/form';
import { useTranslation } from 'react-i18next';
import { validPolishExtendedName } from 'src/shared/validatorUtils';
import { RuleArgs } from '.';

export const cityRule = ({ required }: RuleArgs): Rule => {
  const { t } = useTranslation();

  return ({
    required,
    message: t('Please enter correct city'),
    validator: (_, value: string) => {
      if (required && !value) {
        return Promise.reject();
      }

      return (
        !value || validPolishExtendedName(value)
          ? Promise.resolve()
          : Promise.reject());
    },
  });
};
